import { useEffect } from 'react';
import { withRouter } from '@americanexpress/one-app-router';
import PropTypes from 'prop-types';

const RouteReplaceWithQueryParams = ({ router, to }) => {
  useEffect(() => {
    const { pathname } = router.location;
    const basePath = pathname.startsWith('/lounge-access/')
      ? '/lounge-access'
      : `${pathname.slice(0, pathname.indexOf('/lounges'))}/lounges`;

    router.replace({
      pathname: basePath + to,
      query: router?.location?.query,
    });
  }, [router, to]);
  return null;
};

RouteReplaceWithQueryParams.propTypes = {
  router: PropTypes.shape({
    replace: PropTypes.func.isRequired,
    location: PropTypes.shape({
      query: PropTypes.shape({}),
      pathname: PropTypes.string,
    }),
  }).isRequired,
  to: PropTypes.string.isRequired,
};

export default withRouter(RouteReplaceWithQueryParams);
